import { render } from "./ComingSoon.vue?vue&type=template&id=3635ef51"
import script from "./ComingSoon.vue?vue&type=script&lang=js"
export * from "./ComingSoon.vue?vue&type=script&lang=js"
script.render = render

export default script